const gSelector = {
	html: document.querySelector('html'),
	body: document.querySelector('body'),
	header: document.querySelector('.l-header'),
	headerOpenClass: 'is-navi-open',
};
const breakPoint = {
	a: 768,
	b: 767
};
const windowSize = {
	width: window.innerWidth,
	height: window.innerHeight
};


// PC/SPでクリックイベントを出し分け

const clickOrTouch = () => {
	const isTouchDevice = (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch);
	return (isTouchDevice) ? 'touchend' : 'click';
}
const eventClickOrTouch = clickOrTouch();


// ユーザーエージェント関連

const deviceCategory = {
	mobile: "ua_mobile",
	tablet: "ua_tablet",
	pc: "ua_pc"
};
const deviceParser = () => {
	const ua = navigator.userAgent;
	if(ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0){
		// スマホ
		gSelector.html.classList.add('ua_mobile');
		return deviceCategory.mobile;
	} else if(ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0){
		// タブレット
		gSelector.html.classList.add('ua_tablet');
		document.querySelector('meta[name=viewport]').setAttribute('content', 'width=1300,user-scalable=yes,maximum-scale=2.0');
		return deviceCategory.tablet;
	} else{
		// PC
		gSelector.html.classList.add('ua_pc');
		return deviceCategory.pc;
	}
};
const device = deviceParser();
// example
// if(device == deviceCategory.mobile) console.log("mobile");


// タブレットviewport設定

if(device == deviceCategory.tablet){
	const viewport = document.querySelector('meta[name="viewport"]');
	viewport.setAttribute("content","width=device-1400,initial-scale=1.0,maximum-scale=1.0");
}

// ウィンドウサイズをcss変数に代入

const windowSizeProperty = (() => {
	const windowSizeSetting = () => {
		document.documentElement.style.setProperty('--vh', (window.innerHeight) + 'px');
		document.documentElement.style.setProperty('--vw', (window.innerWidth) + 'px');
	};
	let timeoutID = 0;
	let delay = 500;
	windowSizeSetting();
	if(device == deviceCategory.pc || device == deviceCategory.tablet) {
		window.addEventListener("resize", () => {
			clearTimeout(timeoutID);
			timeoutID = setTimeout(()=>{
				windowSizeSetting();
			}, delay);
		}, false);
	}
})();


// アンカースクロール処理

class AnchorScroll {
	constructor(target) {
		const rect = target.getBoundingClientRect().top;
		const offset = window.pageYOffset;
		const gap = gSelector.header.offsetHeight + parseInt(getComputedStyle(gSelector.header).top);
		const position = rect + offset - gap;
		window.scrollTo({
			top: position,
			behavior: 'smooth',
		});
	}
}


// ヘッダーメニュー開閉

class HeaderMenu {
	constructor() {
		gSelector.body.classList.toggle(gSelector.headerOpenClass);
	}
}


// スクロール監視

class ScrollObserver {
	constructor(props) {
		const $this = this;
		$this.target = props.target; //対象の要素
		$this.options = props.options; // IntersectionObserverのオプション
		$this.activeClass = props.activeClass; // 付与するクラス名
		$this.observeEnd = props.observeEnd; // 要素が見えなくなった時にクラスを削除するか
		if(!$this.target) return;
		const array = Array.prototype.slice.call(document.querySelectorAll($this.target));
		const observer = new IntersectionObserver(ObserverCallback, $this.options)
		array.forEach((tgt) => {
			observer.observe(tgt)
		});
		function ObserverCallback(entries) {
			entries.forEach(function(entry, i) {
				const t = entry.target;
				if (entry.isIntersecting && !t.classList.contains($this.activeClass)) {
					t.classList.add($this.activeClass);
				} else {
					if($this.observeEnd == true)
					t.classList.remove($this.activeClass);
				}
			});
		};
	}
}
const primaryScrollObserver = new ScrollObserver({
	target:'.js-intersection',
	activeClass:'is-intersect',
	options:{
		root: null,
		rootMargin: "-30% 0px",
		threshold: 0
	}
});


// ページャーつきswiper
// ※デフォルト機能だと不安定なため

class PaginationSlider {
	constructor(props) {
		// 定義
		$this = this;
		$this.base = props.base; // 要素をかこむラッパー
		$this.slider = props.slider; // スライダーにしたい要素
		$this.sliderItem = props.sliderItem; // スライドにしたい要素
		$this.options = props.options; // swiperのオプション
		// 処理開始
		const paginationSlider = Array.prototype.slice.call(document.querySelectorAll($this.base));
		paginationSlider.forEach((target,index) => {
			const paginationSliderSet = {
				slider : target.querySelector($this.slider),
				sliderItem : target.querySelectorAll($this.sliderItem),
				pagination : target.querySelector('.m-slider-pagination'),
				paginationItem : "",
				paginationElement:"",
			}
			// スライドが2枚以上ならページャー生成
			if(paginationSliderSet.sliderItem.length > 1) {
				if(target.querySelector('.m-slider-pagination__item')) return;
				for(var i=1; i<=paginationSliderSet.sliderItem.length; i++) {
					paginationSliderSet.paginationElement = document.createElement('li');
					paginationSliderSet.paginationElement.textContent = i;
					if(i==1){
						paginationSliderSet.paginationElement.className = 'm-slider-pagination__item is-current';
					}else{
						paginationSliderSet.paginationElement.className = 'm-slider-pagination__item';
					}

					paginationSliderSet.pagination.appendChild(paginationSliderSet.paginationElement);
				}
			}
			paginationSliderSet.paginationItem = target.querySelectorAll('.m-slider-pagination__item');
			// スライダーに渡したい設定を定義
			let swiperSetting = {};
			if($this.options) {
				swiperSetting = $this.options;
			}
			swiperSetting.on = {
				slideChange: function () {
					console.log('1');
					paginationSliderSet.paginationItem.forEach((target,index) => {
						target.classList.remove('is-current');
					});
					paginationSliderSet.paginationItem[this.realIndex].classList.add('is-current');
				},
			}
			// スライダー作成
			const paginationSliderSwiper = new Swiper(paginationSliderSet.slider, swiperSetting);
			// ページャーでスライド切り替え
			if(paginationSliderSet.paginationItem) {
				paginationSliderSet.paginationItem.forEach((target,index) => {
					target.addEventListener(eventClickOrTouch, function(){
						paginationSliderSwiper.slideTo(index+1);
					});
				});
			}
		});
	}
}
// インスタンス作成例
// const primarySliderTest = new PaginationSlider({
// 	base:'.top-pickup__image',
// 	slider:'.top-pickup__image__slider',
// 	sliderItem:'.top-pickup__image__slider__item',
// 	options:{
// 		effect : "fade",
// 		fadeEffect : {
// 			crossFade: true
// 		}
// 	}
// });


// ロード後クラス追加

window.addEventListener('load', () => {
	gSelector.body.classList.add('is-loaded');
});


// アンカーリンク

const anchorLink = (() => {
	const scrollTrigger = document.querySelectorAll('a[href^="#"]');
	for (let i = 0; i < scrollTrigger.length; i++){
		scrollTrigger[i].addEventListener(eventClickOrTouch, (e) => {
			e.preventDefault();
			let href = scrollTrigger[i].getAttribute('href');
			let targetElement = document.getElementById(href.replace('#', ''));
			const defaultAnchor = new AnchorScroll(targetElement);
		});
	}
	// ページをまたぐアンカーリンク
	const anchorTrigger = document.querySelectorAll('a[data-anchor]');
	for (let i = 0; i < anchorTrigger.length; i++){
		anchorTrigger[i].addEventListener(eventClickOrTouch, (e) => {
			e.preventDefault();
			const data = anchorTrigger[i].getAttribute('data-anchor');
			const anchor = data.split('?');
			const anchorPath = anchor[0];
			const anchorId = anchor[1].split('=')[1];
			const anchorTarget = document.getElementById(anchorId);
			if(anchorPath == location.pathname) {
				// ページが同じならスクロール
				const pageAnchor = new AnchorScroll(anchorTarget);
				// URLに挿入する
				history.replaceState('','',data);
				// メニュー閉じる
				const anchorHeaderClose = new HeaderMenu;
			} else {
				// ページが異なるなら該当ページへ移動させる
				location.href = data;
			}
		});
	}
	// アクセス時にanchorが存在したらスクロールさせる
	window.addEventListener('load', () => {
		if(document.URL.match(/anchor/)) {
			const data = location.href;
			const anchor = data.split('?');
			const anchorId = anchor[1].split('=')[1];
			const anchorTarget = document.getElementById(anchorId);
			const gap = gSelector.header.offsetHeight;
			const loadAnchor = new AnchorScroll(anchorTarget);
		}
	});
})();


// ヘッダーまわり

// 少しスクロールしたら背景同化防止のクラスをつける
const headerSeparate = () => {
	let scrollY = window.pageYOffset;
	const classAddPosition = 150;
	const separateClass = 'is-separate';
	scrollY > classAddPosition ? gSelector.header.classList.add(separateClass): gSelector.header.classList.remove(separateClass);
}
headerSeparate();
window.addEventListener('scroll', () => {
	headerSeparate();
});
// メニュー開閉
const headerHumberger = (() => {
	const target = document.querySelector('.l-header__humberger');
	if(!target) return;
	target.addEventListener(eventClickOrTouch, function(){
		const toggle = new HeaderMenu;
	}, false);
})();
// 子メニュー開閉
const headerChildMenu = (() => {
	const trigger = document.querySelectorAll('.l-header__menu__item--has-child');
	trigger.forEach((target,index) => {
		const childToggle = (target) => {
			const currentClass = 'is-current';
			const wrap = '.l-header__menu__item';
			const thisWrap = target.closest(wrap);
			document.querySelectorAll(wrap).forEach((target,index) => {
				if(target == thisWrap) return;
				target.classList.remove(currentClass);
			});
			thisWrap.classList.toggle(currentClass);
		}
		target.addEventListener(eventClickOrTouch, function(e) {
			childToggle(target);
		});
		target.addEventListener("mouseover", function(e) {
			childToggle(target);
		});
		target.addEventListener("mouseout", function(e) {
			childToggle(target);
		});
	})
})();


// footer

// ページトップ
const footerPagetop = document.querySelector('.l-footer__pagetop')
footerPagetop.addEventListener(eventClickOrTouch, function(){
	new AnchorScroll(document.querySelector('body'));
});
// メニュー開閉
const footerMenu = (() => {
	if (window.matchMedia("(min-width:"+ breakPoint.a +"px)").matches) return;
	const trigger = document.querySelectorAll('.l-footer__navi__item--has-child .l-footer__navi__main-title');
	trigger.forEach((target,index) => {
		target.addEventListener(eventClickOrTouch, function(e) {
			const wrap = target.closest(".l-footer__navi__item");
			e.preventDefault();
			wrap.classList.toggle('is-current');
		});
	})
})();


// トップページ

// fv 画像切替
const topFvImage = () => {
	if (window.matchMedia("(max-width:"+ breakPoint.b +"px)").matches) return;
	const fvTarget = document.querySelector('.top-fv__text-section__area--2');
	if(fvTarget){
		const fvTargetClientRect = fvTarget.getBoundingClientRect();
		const fvTargetScrollY =  fvTargetClientRect.top;
		const fvTargetH = fvTarget.clientHeight;
		const fvImage = document.querySelector('.top-fv__image__item:nth-child(2)');
		if(fvTargetScrollY <= fvTargetH/2) {
			fvImage.classList.add('is-active');
		} else {
			fvImage.classList.remove('is-active');
		}
	}
}
topFvImage();
window.addEventListener('scroll', () => {
	topFvImage();
});
window.addEventListener('resize', () => {
	topFvImage();
});
// news スライダー ※スマホのみ
const topNewsSlider = () => {
	let slider;
	if (windowSize.width <= breakPoint.b) {
		if (slider) {
			return;
		} else {
			const slider = new PaginationSlider({
				base:'.top-news',
				slider:'.top-news__list',
				sliderItem:'.m-article-panel',
				options: {
					loop:true
				}
			});
		}
	} else {
		if (slider) {
			slider.destroy();
			slider = undefined;
		}
	}
}
window.addEventListener('DOMContentLoaded', () => {
	topNewsSlider();
});
window.addEventListener('resize', () => {
	topNewsSlider();
});
// businessMenu
const topBusinessMenu = (() => {
	if(device == deviceCategory.mobile) return; // SPは適用させない
	const menuItem = document.querySelectorAll('.top-business__menu__item');
	const businessImage = document.querySelectorAll('.top-business__cover-image__item');
	if(businessImage.length){
		businessImage[2].classList.add('is-current');
	}
	if(device == deviceCategory.tablet) return; // タブレットここまで
	menuItem.forEach((target,index) => {
		target.addEventListener("mouseenter", function( event ) {
			businessImage.forEach((target,index) => {
				target.classList.remove('is-current');
			});
			businessImage[index].classList.add('is-current');
		}, false);
	})
})();

//jupiter
const efficacyMenu = (() => {
	if (window.matchMedia("(min-width:"+ breakPoint.a +"px)").matches) return;
	const trigger = document.querySelectorAll('.page-jupiter .jupiter-efficacy .jupiter-efficacy__list .jupiter-efficacy__list__btn a');
	trigger.forEach((target,index) => {
		target.addEventListener(eventClickOrTouch, function(e) {
			const wrap = target.closest(".jupiter-efficacy__list__item");
			e.preventDefault();
			wrap.classList.toggle('is-current');
		});
	})
})();

// jupiter support slider
const jupiterSupportSlider = () => {
	let slider;
	if (windowSize.width <= breakPoint.b) {
		if (slider) {
			return;
		} else {
			const slider = new PaginationSlider({
				base:'.jupiter-support',
				slider:'.jupiter-support__list',
				sliderItem:'.jupiter-support__list__item',
				options: {
					loop:false,
					spaceBetween: 20,
					slidesPerView: 1.23
				}
			});
		}
	} else {
		if (slider) {
			slider.destroy();
			slider = undefined;
		}
	}
}
window.addEventListener('DOMContentLoaded', () => {
	jupiterSupportSlider();
});
window.addEventListener('resize', () => {
	jupiterSupportSlider();
});

// incurativer-pro about image
const incurativerProAboutImage = new Swiper(".incurativer-pro-about__image__slider", {
	loop: true,
	loopedSlides: 2,
	slidesPerView: "auto",
	speed: 8000,
	autoplay: {
		delay: 0,
		disableOnInteraction: false,
	},
});

//incurativer-pro support slider
const incurativerProSupportSlider = () => {
	let slider;
	if (windowSize.width <= breakPoint.b) {
		if (slider) {
			return;
		} else {
			const slider = new PaginationSlider({
				base:'.incurativer-pro-support',
				slider:'.incurativer-pro-support__list',
				sliderItem:'.incurativer-pro-support__list__item',
				options: {
					loop:false,
					spaceBetween: 20,
					slidesPerView: 1.16
				}
			});
		}
	} else {
		if (slider) {
			slider.destroy();
			slider = undefined;
		}
	}
}
window.addEventListener('DOMContentLoaded', () => {
	incurativerProSupportSlider();
});
window.addEventListener('resize', () => {
	incurativerProSupportSlider();
});

// フォーム関連
(function(){	
	// Recaptcha v3
	const setupRecaptcha = () => {
		const form = document.querySelector('form[data-recaptcha-form]');
		if(!form) return;
		form.addEventListener('submit', onSubmit);
		function onSubmit(e) {
			e.preventDefault();
			grecaptcha.ready(function() {
				grecaptcha.execute('6LfIHn8sAAAAAPm0w-91SByqEWSmA0WDen3tx3cc', {action: 'submit'}).then(function(token){
					var recaptchaToken = document.getElementById('recaptchaToken');
					recaptchaToken.value = token;
					form.submit();
				});
			});
		}
	}
	// 同意チェック
	const agreeCheck = () => {
		const agreeInput = document.querySelector('.js-agree-check');
		const agreeButton = document.querySelector('.js-agree-button');
		const agreeButtonClass = 'm-button';
		const agreeDisbiled = 'm-button--disbiled';
		if(!agreeInput && !agreeButton) return;
		if(!agreeButton.classList.contains(agreeButtonClass)) return;
		// クラス付与処理
		const agreeClassSet = () => {
			agreeInput.checked ? agreeButton.classList.remove(agreeDisbiled) : agreeButton.classList.add(agreeDisbiled);
		}
		// 表示時
		agreeClassSet();
		// inputクリック時
		agreeInput.addEventListener('click', (e) => {
			agreeClassSet();
		});
	}
	// 初期化
	const initializeForm = () => {
		setupRecaptcha();
		agreeCheck();
	}
	initializeForm();
})();

// m-voice accordion
const voiceAccordion = (() => {
  const head = document.getElementsByClassName('m-voice__sub-ttl'); 
  for(let i = 0; i < head.length; i++){
		head[i].addEventListener('click', (e) => {
      const body = head[i].nextElementSibling;
      head[i].classList.toggle('is-show');
      body.classList.toggle('is-show');
			// img height
			const box = body.closest('.m-voice__img-box');
			const img = body.querySelector('.m-voice__image img');
			if(body.classList.contains('is-show')) {
				const imgHeight = img.clientHeight;
				box.style.minHeight = imgHeight+"px" ;
			} else {
				box.style.minHeight = '';
			}
		});
  }
})();